var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6721 10.7216H19.2538V7.88499C19.2538 3.97355 16.0801 0.799866 12.1623 0.799866C9.17941 0.799866 6.62902 2.65065 5.58596 5.25828L7.96463 6.58118C8.52432 4.794 10.1907 3.49018 12.1623 3.49018C14.5855 3.49018 16.5571 5.4618 16.5571 7.88499V10.7216H3.65886C2.10064 10.7216 0.822266 12 0.822266 13.5582V27.7348C0.822266 29.293 2.10064 30.5714 3.65886 30.5714H20.6721C22.2303 30.5714 23.5087 29.293 23.5087 27.7348V13.5582C23.5087 12 22.2303 10.7216 20.6721 10.7216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/openLock.07c8b57445f65dedbac659118c4792d1.svg";
export { ForwardRef as ReactComponent };